import type { SelectOption } from '@/components/ui/SelectOptions/types';
import type { GetLinesResponseDTO } from '@/core/dto/line/get-lines';

export class GetLinesMapper {
	constructor(private readonly data: GetLinesResponseDTO) {}

	toDomain(): SelectOption[] {
		return this.data.map((value) => ({
			value: value.id,
			label: value.name
		}));
	}
}
